// extracted by mini-css-extract-plugin
export default {"bestButton":"styles_bestButton__3I1oD"};